export enum VriChatParticipant {
  USER = 'user',
  DEAF = 'deaf',
}
